import log, { LogLevelNumbers } from 'loglevel';

import { DevOptions } from './dev-tools/dev-options.model';
import { devOptions } from './dev-tools/dev-options';
import { CommandQueue } from './command-queue/command-queue';
import { loadPersistedLogLevel } from './dev-tools/log-level';
import { PollingManager } from './polling-manager/polling-manager';
import { RequestManager } from './browser-utilities/request-manager';

import { onSiteDisplayListener } from './integrations/onsite-display/onsite-display';
import { browserNotificationListener } from './integrations/browser-notification/browser-notification';
import { exitIntentListener, ExitIntentManager } from './integrations/exit-intent/exit-intent';
import { CookieManager } from './browser-utilities/cookie-manager';

// TODO: improve on readability etc. Also the the file and line trace gets fucked up...
// Somehow fix this by using binding not wrapping, like to original dude does: https://github.com/pimterry/loglevel/blob/master/lib/loglevel.js
function setLogLevelPrefixing() {
  const originalFactory = log.methodFactory;
  log.methodFactory = function (methodName: string, logLevel: LogLevelNumbers, loggerName: string) {
      var rawMethod = originalFactory(methodName, logLevel, loggerName);
      return function () {
        var messages = [`%cce-log ${methodName}:`, 'color:#041041; font-weight: bold; text-transform: uppercase;'];
        for (var i = 0; i < arguments.length; i++) {
          messages.push(arguments[i]);
        }
        rawMethod(...messages);
      };
  };
  log.setLevel(log.getLevel(), false);
}

/**
 * Initializes the SDK and the xng function object.
 * Executes all queued up elements from the pre-load xng array.
 * @param preLoadQueue passes an array of commands from the pre-load xng array.
 */
export function init(preLoadQueue: {q: unknown[][]}) {
  // init log level
  loadPersistedLogLevel();
  setLogLevelPrefixing();

  // create global function object
  window[window.CrossEngageObject] = Object.assign(CommandQueue.add.bind(CommandQueue), devOptions);

  // store queue on unload
  window.addEventListener('beforeunload',
    CommandQueue.storeSessionQueue.bind(CommandQueue, ['track', 'identify', 'update'])
  );

  // check if an upcoming exit intent is stored and should be initialized
  ExitIntentManager.checkStoredExitIntent();

  // init command queue execution
  if (preLoadQueue.q) {
    // This inserts a legacy cookie conversion directly
    // after the initial configuration command into the command queue
    // to ensure all legacy cookie settings are available in any other following command.
    preLoadQueue.q.splice(1, 0,
      [function() { CookieManager.convertLegacyCookies(); }],
      // retrieves and adds commands that were stored in the session storage
      ... CommandQueue.retrieveSessionQueue()
    );

    // copies the array to access values in console.
    log.debug('Starting execution of pre-load array:', [...preLoadQueue.q]);
    preLoadQueue.q.forEach(function(args) {
      window[window.CrossEngageObject](...args);
    });
  }

  // start polling
  PollingManager.startPolling();

  // Internal Subscriptions for request listening.
  RequestManager.subscribeToResponse(onSiteDisplayListener);
  RequestManager.subscribeToResponse(browserNotificationListener);
  RequestManager.subscribeToResponse(exitIntentListener);
  RequestManager.subscribeToResponse((body) => PollingManager.checkRequestStartStopPolling(body));
}
